import { Component, OnInit } from '@angular/core';

import { SharedService } from '../../../services/shared.service';

import { MenuDTO } from 'src/app/models/menu-dto';
import { Item } from 'src/app/models/menu-dto';
import { StihlUserDTO } from '../../../models/stihl-user-dto';
import { UserService } from '../../../services/user.service';

import { visibleContentAnimation } from '../../../animations';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  animations: [visibleContentAnimation],
})
export class SidebarComponent {

  user!: StihlUserDTO;
  menu!: MenuDTO;
  items!: Item[];

  constructor(
    private sharedService: SharedService,
    private userService: UserService
    ) {
    this.getUser();
    this.getMenu();
  }

  getUser() {
    this.userService.getUserData().subscribe(resp => {
      this.user = resp;
    });
  }

  getMenu() {
    this.sharedService.getMenu().subscribe(resp => {
      this.menu = resp;
      this.items = this.menu.Items;
    });
  }
}
